/**
 * Rebuy adds `rebuy-cart-visible` to <body> while the Smart Cart is open, which locks page
 * scroll. The class can be left behind when the cart closes (e.g. after the cart is emptied),
 * so remove it once the Smart Cart is no longer actually showing on screen.
 *
 * Visibility is judged from the rendered DOM, not Rebuy's `visible` flag or `.is-visible`
 * class, because both can be stale after the cart empties.
 */
(() => {
  if (window.__ellisRebuyScrollFix) return;
  window.__ellisRebuyScrollFix = true;

  const BODY_CLASS = 'rebuy-cart-visible';
  const CART_SELECTOR =
    '.rebuy-cart__flyout, #rebuy-cart, #rebuy-smart-cart, .rebuy-cart, .rebuy-smart-cart';
  const CHECK_INTERVAL = 300;
  const CLOSED_CHECKS_REQUIRED = 2;

  let timer = null;
  let closedChecks = 0;

  const isRendered = (el) => {
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
      return false;
    }
    const rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    // Flyouts slide in/out with a transform; off-screen means closed.
    return rect.right > 0 && rect.bottom > 0 && rect.left < window.innerWidth && rect.top < window.innerHeight;
  };

  const isSmartCartShowing = () => Array.from(document.querySelectorAll(CART_SELECTOR)).some(isRendered);

  const stop = () => {
    clearInterval(timer);
    timer = null;
    closedChecks = 0;
  };

  const check = () => {
    if (!document.body.classList.contains(BODY_CLASS)) {
      stop();
      return;
    }
    if (isSmartCartShowing()) {
      closedChecks = 0;
      return;
    }
    // Require consecutive "closed" readings so an opening animation is not mistaken for closed.
    closedChecks += 1;
    if (closedChecks >= CLOSED_CHECKS_REQUIRED) {
      document.body.classList.remove(BODY_CLASS);
      stop();
    }
  };

  const start = () => {
    if (timer) return;
    closedChecks = 0;
    timer = setInterval(check, CHECK_INTERVAL);
  };

  const init = () => {
    // Re-evaluate whenever the class is (re)applied to <body>.
    new MutationObserver(() => {
      if (document.body.classList.contains(BODY_CLASS)) start();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('rebuy:smartcart.hide', start);
    document.addEventListener('rebuy:cart.change', () => {
      if (document.body.classList.contains(BODY_CLASS)) start();
    });

    if (document.body.classList.contains(BODY_CLASS)) start();
  };

  if (document.body) init();
  else document.addEventListener('DOMContentLoaded', init);
})();
